// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Jv7kv","location":"Header_location__1DODi"};